import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'cacaus-card',
  templateUrl: './cacaus-card.component.html',
  styleUrls: ['./cacaus-card.component.scss'],
})
export class CacausCardComponent implements OnInit {
  @Input() public redirectExtrato: boolean = false;
  @Input() public pontuacao: number = 0;
  @Input() public minimo: boolean = false;
  @Input() public idNivel: number = 0;
  @Input() public legenda: string = '';

  public screenWidth: number = window.screen.width;

  constructor(private router: Router) {}

  ngOnInit(): void {
    const card = document.getElementById('card');
    let tiltX = 0;
    let tiltY = 0;
    let isTilting = false;

    card.addEventListener('mousemove', tiltCard);

    function tiltCard(event) {
      // const cardWidth = card.offsetWidth;
      // const cardHeight = card.offsetHeight;
      // const cardCenterX = card.offsetLeft + cardWidth / 2;
      // const cardCenterY = card.offsetTop + cardHeight / 2;

      // const mouseX = event.pageX - cardCenterX;
      // const mouseY = event.pageY - cardCenterY;

      // const maxTilt = 40;

      // tiltX = (mouseY / cardHeight) * maxTilt;
      // tiltY = (mouseX / cardWidth) * maxTilt;

      // if (!isTilting) {
      //   isTilting = true;
      //   requestAnimationFrame(updateCardTransform);
      // }
    }

    function updateCardTransform() {
      card.style.transform = `perspective(1000px) rotateX(${tiltX}deg) rotateY(${tiltY}deg)`;

      if (Math.abs(tiltX) > 0.1 || Math.abs(tiltY) > 0.1) {
        requestAnimationFrame(updateCardTransform);
      } else {
        isTilting = false;
      }
    }

    card.addEventListener('mouseleave', resetCard);

    function resetCard() {
      tiltX = 0;
      tiltY = 0;
    }
  }

  onClick() {
    if (!this.redirectExtrato) return;

    this.router.navigate(['/extrato']);
  }
}
